import TIM from 'tim-js-sdk'
import COS from "cos-js-sdk-v5";
import AppData from '../model/AppData';
import DeviceEventEmitter, { EventName } from '../control/event';


export default class TIMUtils {

    static isLogin = false;
    static isJoinGroupOk = false;
    static isReady = false;
    static MESSAGE_RECEIVED = TIM.EVENT.MESSAGE_RECEIVED;
    static tim = null;
    static nickName = '';
    static EventCall = [];
    static PRIMSG = [];

    static init(appId) {
        if (!TIMUtils.tim) {
            TIMUtils.tim = TIM.create({ SDKAppID: appId });
            if (process.env.REACT_APP_ENV == 'production') {
                TIMUtils.tim.setLogLevel(1);
            } else {
                TIMUtils.tim.setLogLevel(0);
            }
            TIMUtils.tim.registerPlugin({ 'cos-js-sdk': COS });
            TIMUtils.tim.on(TIM.EVENT.MESSAGE_RECEIVED, TIMUtils.onMessageReceived);
            TIMUtils.tim.on(TIM.EVENT.SDK_READY, TIMUtils.onReady);
            TIMUtils.tim.on(TIM.EVENT.SDK_NOT_READY, TIMUtils.onSdkNotReady);
        }
    }

    static onReady(event) {
        console.log('onReady', event);
        TIMUtils.isReady = true;
        if (TIMUtils.isLogin) {
            TIMUtils.getMyProfile();
            // TIMUtils.updateMyProfile();
        }
        DeviceEventEmitter.emit(EventName.EVENT_TIM_READY, event);
    }

    static onSdkNotReady(event) {
        console.log('onSdkNotReady', event);
    }

    static onMessageReceived(event) {
        console.log('onMessageReceived', event);
        if (event && event.data) {
            for (let i = 0; i < event.data.length; i++) {
                if (event.data[i].conversationType == 'C2C') {
                    if (TIMUtils.isMessageText(event.data[i].type) || TIMUtils.isMessageImage(event.data[i].type)) {
                        TIMUtils.PRIMSG.push(event.data[i]);
                    }
                }
            }
        }

        DeviceEventEmitter.emit(EventName.EVENT_TIM_MESSAGE_RECEIVED, event);
    }

    static getChatId(userID) {
        return 'customer_' + userID;
    }

    static getHostChatId(userID) {
        return 'host_' + userID;
    }

    static getService() {
        // const service_ = 'service_';
        // if (from.startsWith(service_)) {
        //     return from.substring(service_.length)
        // }
        return 'service_';
    }

    static logout(callback) {
        if (!TIMUtils.isLogin) return;

        let promise = TIMUtils.tim.logout();
        promise.then(function (imResponse) {
            console.log(imResponse.data); // 登出成功
            TIMUtils.isLogin = false;
            callback && callback();
        }).catch(function (imError) {
            console.warn('logout error:', imError);
        });
    }

    static login(userID, userSig) {
        if (TIMUtils.isLogin) {
            return;
        }
        TIMUtils.tim.login({ userID: userID, userSig: userSig }).then(res => {
            console.log(res);
            if (res.code == 0) {
                TIMUtils.isLogin = true;
            }
        })
    }

    static getMyProfile() {
        let promise = TIMUtils.tim.getMyProfile();
        if (promise) {
            promise.then(function (imResponse) {
                console.log('getMyProfile', imResponse);
                if (imResponse.code == 0 && imResponse.data) {
                    TIMUtils.nickName = imResponse.data.nick;
                }
            }).catch(function (imError) {
                console.warn('getMyProfile error:', imError); // 更新资料失败的相关信息
            });
        }
    }

    static updateMyProfile() {
        console.log('updateMyProfile', AppData.me.Username, AppData.me.Pic);
        let promise = TIMUtils.tim.updateMyProfile({
            nick: AppData.me.Username,
            avatar: AppData.me.Pic,
            gender: TIM.TYPES.GENDER_MALE,
            selfSignature: '',
            allowType: TIM.TYPES.ALLOW_TYPE_ALLOW_ANY
        });
        if (promise) {
            promise.then(function (imResponse) {
                console.log('updateMyProfile', imResponse.data); // 更新资料成功
            }).catch(function (imError) {
                console.warn('updateMyProfile error:', imError); // 更新资料失败的相关信息
            });
        }
    }

    static sendTextMessage(roomId, text) {
        if (!text || text.length == 0 || !roomId || roomId.length == 0) {
            return;
        }
        if (!TIMUtils.isLogin) {
            return false;
        }
        if (!TIMUtils.isJoinGroupOk) {
            TIMUtils.joinGroup(roomId);
            return;
        }
        let message = TIMUtils.tim.createTextMessage({
            to: roomId,
            conversationType: TIM.TYPES.CONV_GROUP,
            priority: TIM.TYPES.MSG_PRIORITY_NORMAL,
            payload: {
                text: text
            }
        });
        console.log('sendTextMessage', message);
        return TIMUtils.tim.sendMessage(message);
    }

    static sendGroupMessage(groupID, text) {
        if (!text || text.length == 0 || !groupID || groupID.length == 0) {
            return;
        }
        if (!TIMUtils.isLogin || !TIMUtils.isReady) {
            return;
        }

        let message = TIMUtils.tim.createTextMessage({
            to: groupID,
            conversationType: TIM.TYPES.CONV_GROUP,
            priority: TIM.TYPES.MSG_PRIORITY_NORMAL,
            payload: {
                text: text
            }
        });
        console.log('sendTextMessage', message);
        return TIMUtils.tim.sendMessage(message);
    }

    static sendC2CMessage(userID, text) {
        if (!text || text.length == 0 || !userID || userID.length == 0) {
            return;
        }
        if (!TIMUtils.isLogin || !TIMUtils.isReady) {
            return;
        }
        let message = TIMUtils.tim.createTextMessage({
            to: userID,
            conversationType: TIM.TYPES.CONV_C2C,
            priority: TIM.TYPES.MSG_PRIORITY_NORMAL,
            payload: {
                text: text
            }
        });
        console.log('sendC2CMessage', message);
        return TIMUtils.tim.sendMessage(message);
    }

    static sendImageMessage(userID, images) {
        if (!images || !userID || userID.length == 0) {
            return;
        }
        if (!TIMUtils.isLogin || !TIMUtils.isReady) {
            return;
        }
        let message = TIMUtils.tim.createImageMessage({
            to: userID,
            conversationType: TIM.TYPES.CONV_C2C,
            priority: TIM.TYPES.MSG_PRIORITY_NORMAL,
            payload: {
                file: images
            }
        })
        return TIMUtils.tim.sendMessage(message);
    }

    static sendGroupImageMessage(groupID, images) {
        if (!images || !groupID || groupID.length == 0) {
            return;
        }
        if (!TIMUtils.isLogin || !TIMUtils.isReady) {
            return;
        }
        let message = TIMUtils.tim.createImageMessage({
            to: groupID,
            conversationType: TIM.TYPES.CONV_GROUP,
            priority: TIM.TYPES.MSG_PRIORITY_NORMAL,
            payload: {
                file: images
            }
        })
        return TIMUtils.tim.sendMessage(message);
    }


    static joinGroup(roomId) {
        console.log('joinGroup roomId==========>', roomId);
        if (!TIMUtils.isLogin) {
            return new Promise(resolve => {
                resolve({ code: 101 });
            });
        }
        return new Promise(resolve => {
            TIMUtils.tim.joinGroup({ groupID: roomId, type: TIM.TYPES.GRP_AVCHATROOM }).then(res => {
                console.log('joinGroup==========>', res);
                if (res.code == 0) {
                    TIMUtils.isJoinGroupOk = true;
                    TIMUtils.getGroupProfile(roomId);
                    resolve(res);
                }
            });
        })
    }

    static quitGroup(roomId) {
        if (!TIMUtils.isReady) {
            return;
        }
        TIMUtils.tim.quitGroup(roomId).then(res => {
            console.log('quitGroup==========>', res);
        });
    }

    static getGroupProfile(groupID) {
        if (!TIMUtils.isReady) {
            return;
        }
        TIMUtils.tim.getGroupProfile({ groupID: groupID }).then(res => {
            console.log('getGroupProfile==========>', res);
        });
    }

    static getGroupHistoryMessageList(roomId, pageNum, pageSize) {
        if (!TIMUtils.isReady) {
            return;
        }
        return TIMUtils.tim.getMessageList({
            conversationID: 'GROUP' + roomId,
            nextReqMessageID: pageNum,
            count: pageSize,
        });
    }

    static getC2CHistoryMessageList(userID, pageNum, pageSize) {
        if (!TIMUtils.isReady) {
            return new Promise(resolve => {
                resolve(false);
            });
        }
        return TIMUtils.tim.getMessageList({
            conversationID: 'C2C' + userID,
            nextReqMessageID: pageNum,
            count: pageSize,
        });
    }

    static isMessageText(type) {
        return type == TIM.TYPES.MSG_TEXT;
    }

    static isMessageImage(type) {
        return type == TIM.TYPES.MSG_IMAGE;
    }

    static isSysMessage(type) {
        return type == TIM.TYPES.MSG_GRP_SYS_NOTICE;
    }

    static getConversationList() {
        if (!TIMUtils.isReady) {
            return;
        }
        return TIMUtils.tim.getConversationList();
    }

    static getConversationProfile(conversationID) {
        if (!TIMUtils.isReady) {
            return;
        }
        return TIMUtils.tim.getConversationProfile(conversationID);
    }

    static getGroupList() {
        if (!TIMUtils.isReady) {
            return;
        }
        return TIMUtils.tim.getGroupList();
    }

    static getFriendList() {
        if (!TIMUtils.isReady) {
            return;
        }
        return TIMUtils.tim.getFriendList();
    }

    static checkoutConversation(conversationID, prevConversationID) {
        if (!TIMUtils.isReady) {
            return;
        }
        if (prevConversationID) {
            TIMUtils.tim.setMessageRead({ prevConversationID });
        }
        TIMUtils.tim.setMessageRead({ conversationID });

        return TIMUtils.tim.getConversationProfile(conversationID).then((data) => {

        })
    }

    static setMessageRead(conversationID) {
        if (!TIMUtils.isReady) {
            return;
        }
        let promise = TIMUtils.tim.setMessageRead({ conversationID: conversationID });
        if (promise) {
            promise.then((response) => {
                console.log('setMessageRead', response);
            }).catch(err => {
                console.log('setMessageRead', err);
            });
        }
    }

    static getUserProfile(userIDList) {
        if (!TIMUtils.isReady) {
            return;
        }
        return TIMUtils.tim.getUserProfile({ userIDList: userIDList });
    }
}